import React from 'react';

/**
 * 加载动画组件 - 用于代码分割时的加载状态
 * 
 * @param {Object} props - 组件属性
 * @param {string} props.className - 额外的CSS类名
 * @param {string} props.text - 加载提示文本
 */
const LoadingSpinner = ({ className = '', text = '加载中...' }) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="text-gray-600">{text}</p>
    </div>
  );
};

export default LoadingSpinner; 